import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@store/store";
import PatientSelect from "@components/PatientSelect/PatientSelect";
import { selectPatientId } from "@store/homeSlice";
import { useGetAccountsQuery } from "@store/accountApi";
import { AccountType } from "@models/account";
import { useNavigate } from "react-router-dom";
import { ADD_PATIENT_FLOW } from "@components/Onboarding/onboardingFlow";
import { IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const HomePatientSelect: FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patients = useSelector((state: RootState) => state.home.patients);
  const selectedPatientId = useSelector(
    (state: RootState) => state.home.selectedPatientId,
  );
  const { data: accounts } = useGetAccountsQuery();
  const account = accounts?.data?.[0];
  const canAddPatient = account?.type === AccountType.Organization;

  const onSelectPatient = (patientId: string | null) => {
    dispatch(selectPatientId(patientId));
  };

  const onAddPatient = () => {
    navigate(`/onboarding/profile?flow=${ADD_PATIENT_FLOW}`);
  };

  return (
    <Container>
      <PatientSelect
        patients={patients}
        selectedPatientId={selectedPatientId}
        onChange={onSelectPatient}
      />
      {canAddPatient && (
        <IconButton
          aria-label={t("patientSelect.addPatient")}
          title={t("patientSelect.addPatient")}
          size="small"
          onClick={onAddPatient}
          sx={{
            backgroundColor: "primary.main",
            color: "primary.contrastText",
            width: 28,
            height: 28,
            "&:hover": {
              backgroundColor: "primary.dark",
            },
          }}
        >
          <AddIcon fontSize="small" />
        </IconButton>
      )}
    </Container>
  );
};

export default HomePatientSelect;
